import React, { Component } from 'react';
import './App.css';
import { render } from 'react-dom';

class ViewExpense extends Component {
    constructor(props){
      super(props);
      this.state={
       
      }
      console.log("props", props)

    }

    render(){
        return <div>
            <h1>TSTTTTTTTTTTTTTTTTTTT </h1>
        </div>
    }
}

export default ViewExpense;




// WEBPACK FOOTER //
// ./src/ViewExpense.js